


const AnnualTopUp={
          
  series: [{
      name: "TopUp",
      data: [0, 0, 0, 0, 0, 0, 0, 0,0]
  }],
  options: {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false
      }
    },colors: [ '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
    '#f48024', '#69d2e7', '#69d2e7', '#69d2e7'
  ],
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'straight'
    },
    title: {
      text: 'Topup Transactions by Month',
      align: 'center'
    },
    grid: {
      row: {
        colors: ['transparent'],
      },
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    }
  },


}

  export {AnnualTopUp};